export default __webpack_public_path__ + "static/media/minus.cd170c1e.svg";